import { render } from "./opModalContainer.vue?vue&type=template&id=879bf112&scoped=true&ts=true"
import script from "./opModalContainer.vue?vue&type=script&lang=ts"
export * from "./opModalContainer.vue?vue&type=script&lang=ts"

import "./opModalContainer.vue?vue&type=style&index=0&id=879bf112&scoped=true&lang=css"
import "./opModalContainer.vue?vue&type=style&index=1&id=879bf112&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-879bf112"]])

export default __exports__